import { useSelector } from 'react-redux';
import styles from './NotificationsSystem.module.css';

const css = `
    .alert-success {
        color: rgba(10, 54, 34, 1);
        background: rgba(209, 231, 221, 0.8);
        border-color: rgba(163, 207, 187, 0.8);
    }
    .alert-success a {
        color: rgba(10, 54, 34, 1);
    }
    .alert-danger {
        color: rgba(88, 21, 28, 1);
        background: rgba(248, 215, 218, 0.8);
        border-color: rgba(241, 174, 181, 0.8);
    }
    .alert-danger a {
        color: rgba(88, 21, 28, 1);
    }
    .alert-info {
        color: rgba(5, 81, 96, 1);
        background: rgba(207, 244, 252, 0.8);
        border-color: rgba(158, 234, 249, 0.8);
    }
    .alert-info a {
        color: rgba(5, 81, 96, 1);
    }
    .alert-warning {
        color: rgba(102, 77, 3, 1);
        background: rgba(255, 243, 204, 0.8);
        border-color: rgba(255, 230, 156, 0.8);
    }
    .alert-warning a {
        color: rgba(102, 77, 3, 1);
    }
`;

export const NotificationsSystem = () => {

    const { notifications } = useSelector(state => state.ui);

    return (
        <>
            <style>{ css }</style>
            <div className={"notification-layout-margin " + styles.notificationsContainer}>
                {notifications.map(noty => {

                    return <div key={ noty.id } className={styles.notificationContainer}>
                        <div className={"alert alert-" + noty.type + " " + styles.notification} role="alert">{noty.content}</div>
                    </div>

                })}
            </div>
        </>
    )
}
